import { render, staticRenderFns } from "./dialogLb.vue?vue&type=template&id=1413a737&scoped=true"
import script from "./dialogLb.vue?vue&type=script&lang=js"
export * from "./dialogLb.vue?vue&type=script&lang=js"
import style0 from "./dialogLb.vue?vue&type=style&index=0&id=1413a737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413a737",
  null
  
)

export default component.exports